import React, { useEffect, useMemo, useRef, useState } from "react";
import { Dropdown } from "antd";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import ClickAwayListener from "@mui/base/ClickAwayListener";
import { toastify } from "../../helperFunctions/toastify";
import DateInput from "./DateInput";

export default function FilterComponent(props) {
	const [searchString, setSearchString] = useState("");
	const [selectedGender, setSelectedGender] = useState();
	const [active, setActive] = useState(true);
	const [open, setOpen] = useState(false);
	const [tempArr, setTempArr] = useState([]);
	const [tempOption, setTempOption] = useState([]);
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();

	useMemo(() => {
		if (props?.array) {
			setTempArr([...props?.array]);
		}
	}, [props?.array]);
	useMemo(() => {
		if (props?.options && tempOption?.length == 0) {
			console.log(tempOption);
			const arr = props?.options?.map((o) => {
				return {
					...o,
					isChecked: false,
				};
			});
			setTempOption([...arr]);
		}
	}, [props?.options]);
	const checkEmpty = (arr1) => {
		if (arr1.length === 0) {
			toast.warning("No Results Found", {
				position: "bottom-right",
				autoClose: 2000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
			});
		}
	};

	const submitSearch = () => {
		setOpen(false);

		if (searchString && searchString !== "") {
			if (props.value === "AccountNumber") {
				let arr = props.array?.filter((e) =>
					e?.accountNumber?.includes(searchString),
				);
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props.value === "PatientName") {
				let arr = props.array?.filter((e) =>
					e?.patientProfile?.fullName
						?.toLowerCase()
						?.includes(searchString.toLowerCase()),
				);
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props.value === "ContactNo") {
				let arr = props.array?.filter((e) =>
					e?.patientProfile?.contactNo
						?.toLowerCase()
						?.includes(searchString.toLowerCase()),
				);
				checkEmpty(arr);
				props.setArray(arr);
			}
			else if (props.value === "QName") {
				let arr = props.array?.filter((e) =>
					e?.question
						?.toLowerCase()
						?.includes(searchString.toLowerCase()),
				);
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props.value === "Username") {
				let arr = props.array?.filter((e) =>
					e?.username
						?.toLowerCase()
						?.includes(searchString.toLowerCase()),
				);
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props.value === "NationalId") {
				let arr = props.array?.filter((e) =>
					e?.patientProfile?.nationID?.includes(searchString),
				);
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props.value === "StaffContact") {
				let arr = props.array?.filter((e) =>
					e?.contactNumber?.includes(searchString),
				);
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props.value === "Email") {
				let arr = props.array?.filter((e) =>
					e?.email
						?.toLowerCase()
						?.includes(searchString.toLowerCase()),
				);
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props.value === "DotPhrases") {
				let arr = props.array?.filter((e) =>
					e?.dot_phrases
						?.toLowerCase()
						?.includes(searchString.toLowerCase()),
				);
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props.value === "DotTitle") {
				let arr = props.array?.filter((e) =>
					e?.title
						?.toLowerCase()
						?.includes(searchString.toLowerCase()),
				);
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props.value === "Address") {
				let arr = props.array?.filter((e) =>
					e?.address
						?.toLowerCase()
						?.includes(searchString.toLowerCase()),
				);
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props.value === "Code") {
				let arr = props.array?.filter((e) =>
					e?.code
						?.toLowerCase()
						?.includes(searchString.toLowerCase()),
				);
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props.value === "Name") {
				let arr = props.array?.filter((e) =>
					e?.name
						?.toLowerCase()
						?.includes(searchString.toLowerCase()),
				);
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props?.subArray) {
				let arr = props.array?.filter((e) =>
					e[props?.value]?.find((o) =>
						o?.toLowerCase().includes(searchString.toLowerCase()),
					),
				);
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props?.subChild) {
				let arr = props.array?.filter((e) =>
					e[props?.value][props.subChild]
						?.toLowerCase()
						.includes(searchString.toLowerCase()),
				);
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props?.isNested) {
				const key = props?.value;
				const keys = key.split(".");
				let arr = props.array?.filter((e) => {
					let value = e;
					keys.forEach((k) => {
						value = value[k];
					});
					if (
						typeof value === "string" ||
						typeof value === "number"
					) {
						return value
							?.toLowerCase()
							?.includes(searchString.toLowerCase());
					} else if (typeof value == "boolean") {
						return JSON.stringify(value)
							?.toLowerCase()
							?.includes(searchString.toLowerCase());
					} else if (Array.isArray(value)) {
						if (props.withRef) {
							const tempArr = [...value];
							tempArr.forEach((o) => {
								const refKey = o;
								const refKeys = refKey.split(".");
								refKeys.forEach((k) => {
									value = o[k];
								});
							});
						} else {
							return value?.find((o) => {
								return o
									?.toLowerCase()
									.includes(searchString.toLowerCase());
							});
						}
					} else {
						return false;
					}
				});
				checkEmpty(arr);
				props.setArray(arr);
			} else if (props.dynamicFilter) {
				let arr = props.array?.filter((e) => {
					if (
						typeof e[props?.value] === "string" ||
						typeof e[props?.value] === "number"
					) {
						return e[props?.value]
							?.toLowerCase()
							?.includes(searchString.toLowerCase());
					} else if (typeof e[props?.value] == "boolean") {
						return JSON.stringify(e[props?.value])
							?.toLowerCase()
							?.includes(searchString.toLowerCase());
					} else if (Array.isArray(e[props?.value])) {
						console.log("called");
						return e[props?.value]?.find((o) =>
							o
								?.toLowerCase()
								.includes(searchString.toLowerCase()),
						);
					} else {
						return false;
					}
				});
				checkEmpty(arr);
				props.setArray(arr);
			} else {
				let arr = props.array?.filter((e) => {
					return JSON.stringify(e[props?.value])
						?.toLowerCase()
						?.includes(searchString.toLowerCase());
				});
				checkEmpty(arr);
				props.setArray(arr);
			}
		}
	};

	const submitCheckbox = () => { };

	const submitRadio = () => {
		setOpen(false);
		if (props.value === "Gender") {
			let arr = props.array?.filter(
				(e) => e?.patientProfile?.gender === selectedGender,
			);
			props.setArray(arr);
		} else if (props.value === "Active") {
			let arr = props.array?.filter(
				(e) =>
					e?.isMember.toString().toLowerCase() ===
					active.toLowerCase(),
			);
			props.setArray(arr);
		} else if (props.value === "QActive") {
			let arr = props.array?.filter(
				(e) =>
					e?.isActive.toString().toLowerCase() ===
					active.toLowerCase(),
			);
			props.setArray(arr);
		} else if (props.value === "StaffRole") {
			let arr =
				props.array?.filter((e) =>
					e?.role?.toString().includes(active),
				) || [];
			if (arr.length === 0)
				toastify(`No user with ${active} role`, "error");
			props.setArray(arr);
		} else if (props.value === "QDescription") {
			let arr = props.array?.filter((e) => e?.questionType === active);
			props.setArray(arr);
		} else if (props.value === "ProductType") {
			let arr = props.array?.filter((e) => e.type.name === active);
			props.setArray(arr);
		}
	};

	// useEffect(() => {
	//   window.addEventListener("click", function (e) {
	//     if (
	//       (document?.getElementById("ovly1")
	//         ? document?.getElementById("ovly1")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly2")
	//         ? document?.getElementById("ovly2")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly3")
	//         ? document?.getElementById("ovly3")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly4")
	//         ? document?.getElementById("ovly4")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly5")
	//         ? document?.getElementById("ovly5")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly6")
	//         ? document?.getElementById("ovly6")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly7")
	//         ? document?.getElementById("ovly7")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly8")
	//         ? document?.getElementById("ovly8")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly9")
	//         ? document?.getElementById("ovly9")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly10")
	//         ? document?.getElementById("ovly10")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly11")
	//         ? document?.getElementById("ovly11")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly12")
	//         ? document?.getElementById("ovly12")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly13")
	//         ? document?.getElementById("ovly13")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly14")
	//         ? document?.getElementById("ovly14")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly15")
	//         ? document?.getElementById("ovly15")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly16")
	//         ? document?.getElementById("ovly16")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly17")
	//         ? document?.getElementById("ovly17")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly18")
	//         ? document?.getElementById("ovly18")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly19")
	//         ? document?.getElementById("ovly19")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly20")
	//         ? document?.getElementById("ovly20")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly21")
	//         ? document?.getElementById("ovly21")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly22")
	//         ? document?.getElementById("ovly22")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly23")
	//         ? document?.getElementById("ovly23")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly24")
	//         ? document?.getElementById("ovly24")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly25")
	//         ? document?.getElementById("ovly25")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly26")
	//         ? document?.getElementById("ovly26")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly27")
	//         ? document?.getElementById("ovly27")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly28")
	//         ? document?.getElementById("ovly28")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly29")
	//         ? document?.getElementById("ovly29")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly30")
	//         ? document?.getElementById("ovly30")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly31")
	//         ? document?.getElementById("ovly31")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly32")
	//         ? document?.getElementById("ovly32")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly33")
	//         ? document?.getElementById("ovly33")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly34")
	//         ? document?.getElementById("ovly34")?.contains(e.target)
	//         : false) ||
	//       (document?.getElementById("ovly35")
	//         ? document?.getElementById("ovly35")?.contains(e.target)
	//         : false)
	//     ) {
	//     } else {
	//       setOpen(false);
	//     }
	//   });
	// }, [props]);

	const overlay = (
		<div
			className="ovly0 white-background p-3 d-flex overlay-container"
			onClick={(e) => {
				e.stopPropagation();
			}}
		>
			{props.type === "search" && (
				<div>
					<Form.Control
						placeholder="Search..."
						value={searchString}
						id="ovly35"
						onChange={(e) => setSearchString(e.target.value)}
					/>
					<div className="d-flex mt-3">
						<button
							className="small-button-1 me-2"
							onClick={submitSearch}
						>
							Search
						</button>
						<button
							className="small-button-2"
							onClick={() => {
								setSearchString("");
								props.setArray([]);
								setOpen(false);
							}}
						>
							Reset
						</button>
					</div>
				</div>
			)}

			{props.type === "checkbox" && (
				<div>
					<div>
						<Form.Check
							label={<div className="font-12">Sort Item 1</div>}
							name="group1"
							type={"checkbox"}
						/>
						<Form.Check
							label={<div className="font-12">Sort Item 2</div>}
							name="group1"
							type={"checkbox"}
						/>
						<Form.Check
							label={<div className="font-12">Sort Item 3</div>}
							name="group1"
							type={"checkbox"}
						/>
					</div>
					<div className="d-flex mt-3">
						<button
							className="small-button-1 me-2"
							onClick={submitCheckbox}
						>
							Search
						</button>
						<button
							className="small-button-2"
							onClick={() => {
								setSearchString("");
								props.setArray([]);
								setOpen(false);
							}}
						>
							Reset
						</button>
					</div>
				</div>
			)}
			{props.type === "radio-search" && (
				<div>
					<div id="ovly21">
						{tempOption.map((e) => (
							<Form.Check
								label={<div className="font-12">{e.name}</div>}
								name="group1"
								checked={e.isChecked}
								type={"radio"}
								onChange={() => {
									let tArr = [...props.array];
									tArr = tArr?.filter(
										(o) => o[props.value] == e.id,
									);

									let optArr = tempOption?.map((o) => {
										if (o.id == e.id) {
											return { ...o, isChecked: true };
										}
										return { ...o, isChecked: false };
									});
									setTempOption(optArr);
									setTempArr(tArr);
								}}
							/>
						))}
					</div>
					<div className="d-flex mt-3">
						<button
							className="small-button-1 me-2"
							onClick={() => {
								if (tempArr?.length == 0) {
									toastify(
										props?.message ??
										"Results not found for applied filters",
										"error",
									);
								}
								props.setArray([...tempArr]);
								setTempOption((val) => val);

								// setTempArr(props.array);
								setOpen(false);
							}}
						>
							Search
						</button>
						<button
							className="small-button-2"
							onClick={() => {
								const arr = tempOption?.map((o) => {
									return { ...o, isChecked: false };
								});
								setTempOption(arr);
								setOpen(false);
								setSearchString("");
								props.setArray([]);
								setTempArr([]);
								setActive(false);
							}}
						>
							Reset
						</button>
					</div>
				</div>
			)}
			{props.type === "radio" && (
				<div>
					<div id="ovly21">
						{props.value === "Gender" &&
							props?.options?.map((e) => (
								<Form.Check
									label={<div className="font-12">{e}</div>}
									name="group1"
									type={"radio"}
									onChange={() =>
										e === "Male"
											? setSelectedGender("Male")
											: setSelectedGender("Female")
									}
									checked={selectedGender === e}
								/>
							))}
						{props.value === "Active" &&
							props.options?.map((e) => (
								<Form.Check
									label={<div className="font-12">{e}</div>}
									name="group1"
									type={"radio"}
									onChange={() =>
										e === "True"
											? setActive("True")
											: setActive("False")
									}
									checked={active === e}
								/>
							))}

						{props.value === "QActive" &&
							props.options?.map((e) => (
								<Form.Check
									label={<div className="font-12">{e}</div>}
									name="group2"
									type={"radio"}
									onChange={() =>
										e === "True"
											? setActive("True")
											: setActive("False")
									}
									checked={active === e}
								/>
							))}

						{props.value === "StaffRole" &&
							props.options?.map((e) => (
								<Form.Check
									label={<div className="font-12">{e}</div>}
									name="group3"
									type={"radio"}
									onChange={() =>
										e === "staff"
											? setActive("staff")
											: setActive("admin")
									}
									checked={active === e}
								/>
							))}

						{props.value === "QDescription" &&
							props.options?.map((e) => (
								<Form.Check
									label={<div className="font-12">{e}</div>}
									name="group1"
									type={"radio"}
									onChange={() =>
										e === "Yes/No"
											? setActive("Yes/No")
											: e === "Multiple Indicators"
												? setActive("Multiple Indicators")
												: setActive("Text")
									}
									checked={active === e}
								/>
							))}

						{props.value === "ProductType" &&
							props?.options?.map((e) => (
								<Form.Check
									label={<div className="font-12">{e}</div>}
									name="group1"
									type={"radio"}
									onChange={() => setActive(e)}
									checked={active === e}
								/>
							))}
					</div>
					<div className="d-flex mt-3">
						<button
							className="small-button-1 me-2"
							onClick={submitRadio}
						>
							Search
						</button>
						<button
							className="small-button-2"
							onClick={() => {
								setOpen(false);
								setSearchString("");
								props.setArray([]);
								setActive(false);
							}}
						>
							Reset
						</button>
					</div>
				</div>
			)}
			{props.type === "date" && (
				<>
					<div>
						<b className="m-2">From:</b>
						<DateInput
							value={startDate}
							placeholder="Start Date"
							onChange={(e) => {
								const tempTime = e;
								tempTime.setHours(0);
								tempTime.setMinutes(0);
								tempTime.setSeconds(0);
								tempTime.setMilliseconds(0);

								setStartDate(e);
							}}
						/>
						<b className="m-2">To:</b>
						<DateInput
							placeholder="End Date"
							className=""
							value={endDate}
							onChange={(e) => {
								if (!startDate) {
									toastify(
										"Please select start date",
										"error",
									);
									return;
								}
								if (e < startDate) {
									toastify(
										"End date can't be less than start date",
										"error",
									);
									return;
								}
								const tempTime = e;
								tempTime.setHours(23);
								tempTime.setMinutes(59);
								tempTime.setSeconds(59);
								setEndDate(tempTime);
							}}
						/>
						<div className="d-flex mt-3">
							<button
								className="small-button-1 me-2"
								onClick={() => {
									let tempArr = props.array;
									if (!startDate) {
										toastify(
											"Start Date is missing",
											"error",
										);
										return;
									}
									if (!endDate) {
										toastify(
											"End Date is missing",
											"error",
										);
										return;
									}
									if (props.isNested) {
										tempArr = tempArr.filter(
											(o) =>
												new Date(
													o[props.isNested][
													props.value
													],
												).getTime() >=
												new Date(
													startDate,
												).getTime() &&
												new Date(
													o[props.isNested][
													props.value
													],
												).getTime() <=
												new Date(endDate).getTime(),
										);
									} else {
										tempArr = tempArr.filter(
											(o) =>
												new Date(
													o[props.value],
												).getTime() >=
												new Date(
													startDate,
												).getTime() &&
												new Date(
													o[props.value],
												).getTime() <=
												new Date(endDate).getTime(),
										);
									}
									checkEmpty(tempArr);
									setOpen(false);

									props.setArray(tempArr);
								}}
							>
								Search
							</button>
							<button
								className="small-button-2"
								onClick={() => {
									props.setArray(props.array);
									// setStartDate();
									// setEndDate();
									setOpen(false);
								}}
							>
								Reset
							</button>
						</div>
					</div>
				</>
			)}
		</div>
	);

	return (
		<Dropdown
			id="ovly22"
			open={open}
			trigger={["click"]}
			onClick={(e) => {
				e.stopPropagation();
			}}
			overlay={overlay}
		>
			<a onClick={() => setOpen(!open)}>
				<i class="fa-solid fa-arrow-down-short-wide cursor-pointer"></i>
			</a>
		</Dropdown>
	);
}
